import { useEffect } from "react";
import LoginForm from "components/Login/LoginForm";
import { useNavigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

export const Login = () => {
  const authContext = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!!authContext?.user) {
      navigate("/");
    }
  }, []);

  return (
    <div className="p-8 flex flex-1 items-center justify-center h-screen">
      <LoginForm />
    </div>
  );
};

export default Login;
